import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=44c2dffe&scoped=true&"
import script from "./popup.vue?vue&type=script&lang=ts&"
export * from "./popup.vue?vue&type=script&lang=ts&"
import style0 from "./popup.vue?vue&type=style&index=0&id=44c2dffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2dffe",
  null
  
)

export default component.exports